import React from 'react';
import { Link } from 'react-router-dom';
export function KidsRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-1977">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1978">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-1979">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-1980">
          <Link to="/mini-troopers" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1981">
            Mini Troopers
          </Link>
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1982">
            Programs Overview
          </Link>
          <Link to="/FamilyKarateClasses.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1983">
            Family Classes
          </Link>
          <Link to="/kids-taekwondo-classes-in-farmington-hills-michigan" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1984">
            Kids Taekwondo
          </Link>
          <Link to="/kids-martial-arts-classes-in-farmington-hills-michigan" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1985">
            Kids Martial Arts
          </Link>
          <Link to="/kids-karate-classes-in-farmington-hills-michigan" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1986">
            Kids Karate
          </Link>
          <Link to="/SignMeUp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1987">
            Start Trial
          </Link>
        </div>
      </div>
    </section>;
}